import React from "react";
import { XCircle } from "lucide-react";
import { IRegularizationRequest } from "../../../store/apis/attendanceRegularization.api";
import { Modal2, Modal2Footer, Modal2Button } from "../../common";
import { TextArea } from "../../common/TextArea";

interface RejectModalProps {
  isOpen: boolean;
  onClose: () => void;
  request?: IRegularizationRequest;
  rejectReason: string;
  setRejectReason: (reason: string) => void;
  onReject: () => void;
  processing: string | null;
  loading?: boolean;
  formatDate: (date: string) => string;
}

const RejectModal: React.FC<RejectModalProps> = ({
  isOpen,
  onClose,
  request,
  rejectReason,
  setRejectReason,
  onReject,
  processing,
  loading,
  formatDate,
}) => (
  <Modal2
    isOpen={isOpen}
    onClose={onClose}
    size="sm"
    title={
      <div className="flex items-center gap-3.5">
        <div className="w-[46px] h-[46px] rounded-full bg-[var(--color-error-light)] flex items-center justify-center flex-none">
          <XCircle className="w-[23px] h-[23px] text-[var(--color-error)]" />
        </div>
        <div>
          <div className="text-[18px] font-extrabold tracking-[-0.02em] text-[var(--color-text-primary)] leading-tight">
            Reject request
          </div>
          <div className="text-[12.5px] text-[var(--color-text-tertiary)] mt-[4px] leading-snug">
            {request
              ? `Add a reason for ${request.userName} — this is shared with the requester.`
              : "Add a reason for the rejection — this is shared with the requester."}
          </div>
        </div>
      </div>
    }
    footer={
      <Modal2Footer>
        <Modal2Button variant="secondary" onClick={onClose} disabled={loading || processing === request?.id}>
          Cancel
        </Modal2Button>
        <Modal2Button
          variant="danger"
          onClick={onReject}
          loading={loading || (request?.id != null && processing === request.id)}
          disabled={loading || processing === request?.id || !rejectReason.trim()}
        >
          Reject Request
        </Modal2Button>
      </Modal2Footer>
    }
  >
    <div className="space-y-4">
      <div>
        <label className="block text-[12.5px] font-semibold text-[var(--color-text-primary)] mb-[7px]">
          Reason for rejection <span className="text-[var(--color-error)] ml-1">*</span>
        </label>
        <TextArea
          value={rejectReason}
          onChange={(value) => setRejectReason(value)}
          placeholder="e.g. Insufficient leave balance, or conflicting team coverage..."
          required
          minRows={4}
        />
      </div>
    </div>
  </Modal2>
);

export default RejectModal;

